import React, {useState, useContext} from "react";
import { Navigate, useNavigate } from "react-router-dom";
import {Button, Checkbox, Form, Input, Modal, Steps, message} from "antd";
import axios from '../pages/Common/axios';
import {postUserAccounts, getFindUserInfo, getAllCodeList, postSaveLog, getCompanyConfig} from '../pages/Common/api';
import AppContext from './AppContext';
import Cookies from 'js-cookie';
import {Spin} from "antd";


function LoginForm({ authenticated }) {
    const { from } = { from: { pathname: "/" } };
    const [spinflag, setSpinflag] = useState(false);
    const myContext = useContext(AppContext);
    const navigate = useNavigate();


    if (authenticated) return <Navigate replace to={from} />;

    const onSubmit = async (values) => {
        if(spinflag===true) return;
        
        try {
            // 사용자인증token 생성
            // values.password="";
            // values.username="";
            setSpinflag(true);

            if(!values.username){
                throw new SyntaxError("아이디에 값이 없습니다. 확인하세요!"); // 사용자 인증에러
            }

            const response = await axios.post(postUserAccounts(), {
                username: values.username,
                password: values.password
            });


            // OTP 설정이 필요한 경우
            if (response.data &&
                (response.data.otp_setup_required === "True" ||
                 response.data.otp_setup_required === true ||
                 (Array.isArray(response.data.otp_setup_required) &&
                  response.data.otp_setup_required.includes("True")))) {

                showOtpSetupModal(response.data.access);
                return;
            }

            // OTP 코드 입력이 필요한 경우
            if (response.data &&
                (response.data.otp_required === true ||
                 response.data.otp_required === "True")) {

                showOtpLoginModal(values.username, values.password);
                return;
            }

            // token이 필요한 API 요청 시 header Authorization에 token 담아서 보내기
            axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access}`;
            axios.defaults.headers.common["X-Electron-App"] = `true`;
            // 사용자 정보 조회
            const flagUsername = await findUserInfo(values.username);

            if(flagUsername !== true){
               throw new SyntaxError("사용자 정보가 없습니다. 다시 로그인해 주세요!");
            }

            // 공통코드 조회
            const flagCommoncode = await findCommonCodeList();
            if(flagCommoncode !== true){
                throw new SyntaxError("공통코드를 가져오지 못했습니다. 다시 로그인해 주세요!");
            }

            // 인증된 사용자의 인증 토큰을 쿠키에 저장
            Cookies.set('access_token', response.data.access);
            Cookies.set('refresh_token', response.data.refresh);
            Cookies.set('auth_user', values.username);
            // Cookies.set('remember_user', values.username);
            
            if(values.remember===true) localStorage.setItem('remember_user', values.username);
            //초기화면으로 이동
            window.location.replace("/");

            // if (flagUsername === true) {
            //     // 인증된 사용자의 인증 토큰을 쿠키에 저장
            //     Cookies.set('access_token', response.data.access);
            //     Cookies.set('refresh_token', response.data.refresh);
            //     Cookies.set('auth_user', values.username);
            //     Cookies.set('remember_user', values.username);
            //     // 공통코드 조회 API
            //     await findCommonCodeList();
            // } else {
            //     throw new SyntaxError("사용자 정보가 없습니다. 다시 로그인해 주세요!");// 사용자 정보 조회 에러
            // }

        } catch (e) {
            if (e instanceof SyntaxError) {
                Modal.error({ title:e.message, okText: "Close"});
            } else if (e.response && e.response.data &&
                      (e.response.data.otp_required ||
                       (e.response.data.error && e.response.data.error.otp_required))) {
                // OTP 코드 입력이 필요한 경우 (에러 응답)
                showOtpLoginModal(values.username, values.password);
            } else if (e.response && e.response.data &&
                      (e.response.data.otp_setup_required === "True" ||
                       e.response.data.otp_setup_required === true ||
                       (Array.isArray(e.response.data.otp_setup_required) &&
                        e.response.data.otp_setup_required.includes("True")) ||
                       e.response.data.error === "OTP 설정이 필요합니다" ||
                       (Array.isArray(e.response.data.error) &&
                        e.response.data.error.includes("OTP 설정이 필요합니다")))) {
                // OTP 설정이 필요한 경우
                Modal.error({
                    title: "OTP 설정이 필요합니다",
                    content: "회사 정책에 따라 OTP 인증이 필수입니다. 시스템 관리자에게 문의하세요.",
                    okText: "확인"
                });
            } else {
                Modal.error({ title: "아이디 혹은 비밀번호를 확인하세요.", okText: "Close" });
            }
        } finally {
            setSpinflag(false);
        };
    };

    // 사용자정보 조회 API
    const findUserInfo = async (user) => {
        const flag = await axios.get(getFindUserInfo(user)).then((response) => {

                if(response.data.length > 0) {
                    Cookies.set('auth_companyCode', response.data[0].company.code_cd);
                    Cookies.set('auth_companyName', response.data[0].company.code_nm);
                    Cookies.set('auth_user', response.data[0].user);
                    Cookies.set('auth_userName', response.data[0].name);
                    Cookies.set('auth_superuser', response.data[0].is_superuser);

                    // 접속 로그 기록(세션정보가 없어서 로그인 후 기록)
                    axios.post(postSaveLog(), {
                        com_cd : response.data[0].company.code_cd,
                        log_type : '/login/',
                        log_user : response.data[0].user,
                        log_url : '/login/',
                        log_param : '',
                    }, {logType:'log'});
                    
                    return true;
                } else {
                    return false;
                }
            }).catch((error) => {
                console.log("LoginForm.js --- 106 error");
                console.dir(error);
                return false;
            });

        return flag;
    };

    // 공통코드 조회 API
    const findCommonCodeList = async () => {

        const flag = await axios.get(getAllCodeList()).then(response => {
            const records = response.data.map(record => ({
                type: record.code_type,
                text: record.code_nm,
                value: record.code_cd
            }));
            //쿠키에 문자열로 변환하여 저장
            records.sort((a, b) => a.text.localeCompare(b.text));
            const dataList = [{ type: 'result_cd', text: '전체', value: '' }, ...records];
            const dataListString = JSON.stringify(dataList);
            localStorage.setItem('code_list', dataListString);

            return true;
        }).catch(error => {
            return false;
        });

        return flag;
    };

    // OTP 설정 모달 표시
    const showOtpSetupModal = async (accessToken) => {
        try {
            // OTP 설정 정보 가져오기
            const response = await axios.get('/accounts/otp/setup/', {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            const { qr_code, secret_key } = response.data;

            let otpModalRef = null;

            const copyToClipboard = (text) => {
                navigator.clipboard.writeText(text).then(() => {
                    message.success('시크릿 키가 복사되었습니다!');
                }).catch(() => {
                    message.error('복사에 실패했습니다.');
                });
            };

            const activateOTP = async () => {
                const otpCode = document.getElementById('otp_verification_code')?.value;

                if (!otpCode || otpCode.length !== 6) {
                    message.error('6자리 인증 코드를 입력하세요.');
                    return;
                }

                try {
                    const activateResponse = await axios.post('/accounts/otp/setup/', {
                        action: 'enable',
                        otp_code: otpCode
                    }, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });

                    if (activateResponse.data.is_enabled) {
                        message.success(activateResponse.data.message || 'OTP가 성공적으로 활성화되었습니다!');
                        otpModalRef?.destroy();

                        // 백업 코드가 있으면 표시
                        if (activateResponse.data.backup_codes) {
                            showBackupCodes(activateResponse.data.backup_codes, activateResponse.data.warning);
                        } else {
                            // 로그인 완료 처리
                            window.location.replace("/");
                        }
                    }
                } catch (error) {
                    message.error('OTP 활성화에 실패했습니다. 인증 코드를 확인하세요.');
                }
            };

            otpModalRef = Modal.info({
                title: "OTP 2단계 인증 설정",
                width: 600,
                maskClosable: false,
                closable: false,
                content: (
                    <div style={{padding: '20px 0'}}>
                        <Steps
                            direction="vertical"
                            size="small"
                            current={2}
                            items={[
                                {
                                    title: 'Google Authenticator 앱 설치',
                                    description: '스마트폰에 Google Authenticator 앱을 설치하세요.',
                                    status: 'finish'
                                },
                                {
                                    title: 'QR 코드 스캔 또는 수동 입력',
                                    description: (
                                        <div style={{marginTop: '16px'}}>
                                            <div style={{textAlign: 'center', marginBottom: '16px'}}>
                                                <img
                                                    src={`data:image/png;base64,${qr_code}`}
                                                    alt="Google Authenticator QR Code"
                                                    style={{
                                                        border: '1px solid #d9d9d9',
                                                        padding: '8px',
                                                        borderRadius: '6px',
                                                        width: '200px',
                                                        height: '200px',
                                                        objectFit: 'contain'
                                                    }}
                                                />
                                            </div>
                                            <div style={{backgroundColor: '#f5f5f5', padding: '12px', borderRadius: '6px'}}>
                                                <p style={{margin: '0 0 8px 0', fontSize: '14px', fontWeight: 'bold'}}>
                                                    수동 입력용 시크릿 키:
                                                </p>
                                                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                    <code style={{
                                                        backgroundColor: 'white',
                                                        padding: '4px 8px',
                                                        borderRadius: '4px',
                                                        fontSize: '12px',
                                                        flex: 1,
                                                        wordBreak: 'break-all'
                                                    }}>
                                                        {secret_key}
                                                    </code>
                                                    <Button
                                                        size="small"
                                                        onClick={() => copyToClipboard(secret_key)}
                                                    >
                                                        복사
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    status: 'process'
                                },
                                {
                                    title: '인증 코드 입력',
                                    description: (
                                        <div style={{marginTop: '16px'}}>
                                            <p style={{marginBottom: '8px', fontSize: '14px'}}>
                                                Google Authenticator에서 생성된 6자리 코드를 입력하세요:
                                            </p>
                                            <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                                                <Input
                                                    id="otp_verification_code"
                                                    placeholder="000000"
                                                    maxLength={6}
                                                    autoComplete="off"
                                                    style={{width: '120px', textAlign: 'center', fontSize: '16px'}}
                                                    onPressEnter={activateOTP}
                                                />
                                                <Button type="primary" onClick={activateOTP}>
                                                    활성화
                                                </Button>
                                            </div>
                                        </div>
                                    ),
                                    status: 'wait'
                                }
                            ]}
                        />
                    </div>
                ),
                footer: null
            });

        } catch (error) {
            Modal.error({
                title: "OTP 설정 정보를 가져올 수 없습니다",
                content: "시스템 관리자에게 문의하세요.",
                okText: "확인"
            });
        }
    };

    // 백업 코드 표시
    const showBackupCodes = (backupCodes, warningMessage) => {
        Modal.info({
            title: "백업 코드 저장",
            width: 500,
            content: (
                <div>
                    <p style={{marginBottom: '16px', color: '#fa8c16'}}>
                        ⚠️ 중요: {warningMessage || '다음 백업 코드들을 안전한 곳에 저장하세요.'}
                    </p>
                    <p style={{marginBottom: '16px', fontSize: '14px'}}>
                        휴대폰을 분실했을 때 이 코드들로 계정에 접근할 수 있습니다.
                    </p>
                    <div style={{
                        backgroundColor: '#f5f5f5',
                        padding: '16px',
                        borderRadius: '6px',
                        fontFamily: 'monospace',
                        fontSize: '14px'
                    }}>
                        {backupCodes.map((code, index) => (
                            <div key={index} style={{marginBottom: '4px'}}>
                                {code}
                            </div>
                        ))}
                    </div>
                </div>
            ),
            okText: "저장했습니다",
            onOk() {
                window.location.replace("/");
            }
        });
    };

    // OTP 로그인 모달 표시
    const showOtpLoginModal = (username, password) => {
        let otpLoginModalRef = null;

        const submitOtpLogin = async () => {
            const otpCode = document.getElementById('otp_login_code')?.value;
            const trustDevice = document.getElementById('trust_device_checkbox')?.checked || false;

            if (!otpCode || otpCode.length !== 6) {
                message.error('6자리 OTP 코드를 입력하세요.');
                return;
            }

            try {
                const response = await axios.post(postUserAccounts(), {
                    username: username,
                    password: password,
                    otp_code: otpCode,
                    trust_device: trustDevice
                });

                // OTP 인증 성공 - 정상 로그인 처리
                if (response.data.access) {
                    message.success('로그인되었습니다.');
                    otpLoginModalRef?.destroy();

                    // 토큰 설정 및 로그인 완료 처리
                    axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access}`;
                    axios.defaults.headers.common["X-Electron-App"] = `true`;

                    // 사용자 정보 조회
                    const flagUsername = await findUserInfo(username);
                    if(flagUsername !== true){
                        throw new SyntaxError("사용자 정보가 없습니다. 다시 로그인해 주세요!");
                    }

                    // 공통코드 조회
                    const flagCommoncode = await findCommonCodeList();
                    if(flagCommoncode !== true){
                        throw new SyntaxError("공통코드를 가져오지 못했습니다. 다시 로그인해 주세요!");
                    }

                    // 쿠키에 토큰 저장
                    Cookies.set('access_token', response.data.access);
                    Cookies.set('refresh_token', response.data.refresh);
                    Cookies.set('auth_user', username);

                    // 메인 페이지로 이동
                    window.location.replace("/");
                }

            } catch (error) {
                if (error.response && error.response.data && error.response.data.otp_invalid) {
                    message.error('잘못된 OTP 코드입니다. 다시 입력하세요.');
                } else {
                    message.error('OTP 인증에 실패했습니다.');
                }
            }
        };

        otpLoginModalRef = Modal.info({
            title: "OTP 인증",
            width: 400,
            maskClosable: false,
            closable: true,
            content: (
                <div style={{padding: '20px 0', textAlign: 'center'}}>
                    <p style={{marginBottom: '20px', fontSize: '16px'}}>
                        Google Authenticator에서 생성된 6자리 코드를 입력하세요
                    </p>
                    <div style={{marginBottom: '20px'}}>
                        <Input
                            id="otp_login_code"
                            placeholder="000000"
                            maxLength={6}
                            autoComplete="off"
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontSize: '18px',
                                height: '40px'
                            }}
                            onPressEnter={submitOtpLogin}
                            ref={(input) => input && setTimeout(() => input.focus(), 200)}
                        />
                    </div>
                    <div style={{marginTop: '16px', backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '6px'}}>
                        <Checkbox id="trust_device_checkbox">
                            이 디바이스를 30일간 신뢰
                        </Checkbox>
                        <p style={{color: '#dc3545', fontSize: '12px', marginTop: '5px', marginBottom: '0'}}>
                            ⚠️ 개인 PC에서만 체크하세요. 공용 PC에서는 위험합니다!
                        </p>
                    </div>
                    <div style={{marginTop: '20px'}}>
                        <Button
                            type="primary"
                            onClick={submitOtpLogin}
                            style={{width: '100px'}}
                        >
                            로그인
                        </Button>
                    </div>
                </div>
            ),
            footer: null
        });
    };

    return (
        <div className='layer_wrap_new'>
            <div className='layer_wrap_login'>
                <Spin key={1} size={"large"}  tip={"connecting..."} spinning={spinflag}>    
                {/* <div style={{position:'absolute', left:'5px', top:'-200px', width:'590px', height:'350px'}}> */}
                <Form   
                    name="basic"
                    labelCol={{span: 6,}}
                    wrapperCol={{span: 14,}}
                    style={{position:'relative', paddingLeft:'380px',paddingTop:'132px',width:'795px', height:'500px', left:"5px",fontSize:'14px', fontWeight:'bold'}}
                    initialValues={{remember: true, username: localStorage.getItem('remember_user')}}
                    onFinish={onSubmit}
                    autoComplete="off"
                >
                    <Form.Item wrapperCol={{offset: 6, span: 14,}}>
                    </Form.Item>
                    {/* <Form.Item label="사용자 ID" name="username" */}
                    <Form.Item label="" name="username"
                            rules={[{required: true, message: 'Please input your username!',},]}
                            style={{fontSize:'16px', fontWeight:'bold'}}>
                        <Input value='' placeholder="ID"  style={{height:'38px', fontSize:'16px', paddingLeft:'5px',width:'350px',backgroundColor:'#efefef'}} />
                    </Form.Item>
                    {/* <Form.Item label="비밀번호" name="password" value={"aa"} */}
                    <Form.Item label="" name="password"
                            rules={[{required: true,message: 'Please input your password!',},]}
                            style={{fontSize:'16px', fontWeight:'bold'}}>
                        <Input.Password placeholder="PASSWORD"      
                        className="custom-password-input"
                        style={{height:'38px', fontSize:'16px', paddingLeft:'5px', paddingTop:'5px',width:'350px',backgroundColor:'#efefef'}}/>
                    </Form.Item>
                    <Form.Item name="remember" valuePropName="checked" wrapperCol={{offset:0, span: 16,}}>      
                        <Checkbox>Remember me.</Checkbox>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 0, span: 14,}}>
                        <Button type="primary" htmlType="submit" 
                        style={{width:'350px', height:'45px', fontSize:'16px', left:'-5px', fontWeight:'bold'}}>Login</Button>
                    </Form.Item>
                </Form>
                {/* </div> */}
                </Spin>
            </div>
        </div>
    );
}

export default LoginForm;